import { render } from "./PointerLink.vue?vue&type=template&id=e96d6874&scoped=true"
import script from "./PointerLink.vue?vue&type=script&lang=js"
export * from "./PointerLink.vue?vue&type=script&lang=js"

import "./PointerLink.vue?vue&type=style&index=0&id=e96d6874&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96d6874"]])

export default __exports__